import { MEMBER_STATUS } from '@adsk/acs-admin-ui-components-helpers';

export const formatPhone = (phone, T) => {
  if (!phone || !phone.number) return T.translate('NO_PHONE_NUMBER');

  const { number, extension, phoneType } = phone;
  const formattedExtension = extension ? `/${extension}` : '';
  const formattedPhoneType = phoneType ? ` (${phoneType})` : '';

  return `${number}${formattedExtension}${formattedPhoneType}`;
};

export const getAccountStatusText = (status, T) => {
  switch (status) {
    case MEMBER_STATUS.ACTIVE:
      return T.translate('STATUS_ACTIVE');
    case MEMBER_STATUS.DISABLED:
      return T.translate('STATUS_DISABLED');
    case MEMBER_STATUS.NOT_INVITED:
      return T.translate('STATUS_NOT_INVITED');
    case MEMBER_STATUS.PENDING:
      return T.translate('STATUS_INVITED');
    default:
      return '';
  }
};
